export const getLocalStorageItem = name => {
  try {
    return JSON.parse(window.localStorage.getItem(name));
  } catch (e) {
    console.error(`Could not retrieve '${name}' from the local storage.`);
  }
};

export const setLocalStorageItem = (name, value) => {
  window.localStorage.setItem(name, JSON.stringify(value));
};
